export default "__VITE_ASSET__CC6Nw7oZ__"